import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mailing-confirmation',
  templateUrl: './mailing-confirmation.component.html',
  standalone: false,
})
export class MailingConfirmationComponent {
  private confirmCallback: (boolean: boolean) => void;
  public message: string;
  public beneficiariesNoMail: string[];

  constructor(public modal: NgbActiveModal) {}

  public async confirm(message: string, beneficiariesNoMail: string[]): Promise<boolean> {
    this.message = message;
    this.beneficiariesNoMail = beneficiariesNoMail;
    return new Promise<boolean>((resolve: (value: boolean) => void): void => {
      this.confirmCallback = (result: boolean): void => {
        this.modal.close();
        resolve(result);
      };
    });
  }

  public accept(): void {
    this.confirmCallback(true);
  }
}
